import React, { useState } from 'react';
import type { Product } from '../../types/product';
export function ProductGallery({
  product
}: {
  product: Product;
}) {
  const [active, setActive] = useState(0);
  const living = product.line === 'living';
  const radius = living ? 'rounded-xl' : '';
  return <div className="flex flex-col-reverse gap-3 lg:flex-row lg:gap-4" data-id="element-475" data-mp="2chbxwg6e6rdk">
      {product.gallery.length > 1 && <ul className="flex gap-3 lg:flex-col" aria-label="Afbeeldingen" data-id="element-476" data-mp="1yhu8pzp6pc3o">
          {product.gallery.map((src, i) => <li key={src} data-id="element-477" data-mp="23how3t9r3jjz" data-mpi={i}>
              <button type="button" onClick={() => setActive(i)} aria-label={`Afbeelding ${i + 1}`} aria-current={active === i} className={`block overflow-hidden border-2 transition-colors duration-150 ${living ? 'rounded-lg' : ''} ${active === i ? living ? 'border-majorelle' : 'border-ink' : 'border-transparent hover:border-line'}`} data-id="element-478" data-mp="23hyotom6k4td">
                <img src={src} alt="" className="h-16 w-16 bg-surface object-cover lg:h-20 lg:w-20" data-id="element-479" data-mp="16tc1qsedf47q" />
              </button>
            </li>)}
        </ul>}
      <div className={`flex-1 overflow-hidden bg-surface ${radius}`} data-id="element-480" data-mp="1gjx8520add17">
        <img src={product.gallery[active]} alt={`${product.name} – ${product.subtitle}`} className="aspect-square w-full object-cover" data-id="element-481" data-mp="1gm9lt2z0h18g" />
      </div>
    </div>;
}